import { CoralogixRum } from '@coralogix/browser'

export function logCognitoExceptionInCoralogix(error: any) {
  logExceptionInCoralogix(error, { apiResponse: error })
}

export function logExceptionInCoralogix(error: any, customData?: unknown, labels?: Record<string, unknown>) {
  // CoralogixRum.captureError requires a real Error instance; wrap if needed.
  const errorToCapture = error instanceof Error ? error : new Error(error?.message ?? String(error))
  CoralogixRum.captureError(errorToCapture, customData, labels)
}

export function logMessageInCoralogix(message: string, context: any = {}) {
  CoralogixRum.info(message, context)
}
